// extracted by mini-css-extract-plugin
export default {"title":"_5438276c28","inner_title":"c0ea95e8f0","charge_btn":"_47754b48b3"};